import './LiveChip.css';
import { LiveDot } from '../../components/LiveDot';
import { t } from '../../copy/strings';
import { useFeedFailing } from '../../state/hooks';

/**
 * "Ao vivo" (§10.2 `LiveChip`): texto com o `LiveDot` de 7 px respirando (A11; parado com movimento reduzido, §15.6.3).
 * Não é clicável nem focável; o ponto é decorativo (`aria-hidden` no `LiveDot`). 124 px fixos, como o `GoLiveButton`,
 * para a troca entre os dois não mudar a largura da trilha (AC-10.2-05).
 */
export function LiveChip({ closed = false }: { closed?: boolean }) {
  // M1 (ORD-F-148): sem nenhum número e com o aviso de falha, a linha do tempo não diz "Ao vivo"
  if (useFeedFailing()) return null;
  // 26/10 (DECISOES §86): na fase `after` a apuração acabou: "Encerrada", com o ponto parado
  return (
    <span class="live-chip" data-testid="live-chip" data-closed={closed ? '' : undefined}>
      <LiveDot variant={closed ? 'replay' : 'live'} />
      <span class="live-chip__label">{t(closed ? 'timeline.closed' : 'timeline.live')}</span>
    </span>
  );
}
